import { render, staticRenderFns } from "./Wp_mt_order_count_detail_page.vue?vue&type=template&id=c98de75e&scoped=true&"
import script from "./Wp_mt_order_count_detail_page.vue?vue&type=script&lang=js&"
export * from "./Wp_mt_order_count_detail_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98de75e",
  null
  
)

export default component.exports